import { MessageProcessor } from '@/services/websocketProcessorTypes'
import store from '@/redux/store'
import {
  addMessage,
  updateTestChatMessage,
  setIsGenerating,
  setError,
  setExistingTestChats,
} from '@/redux/slices/testChatSlice'
import { commonProcessors } from '@/services/websocketProcessors/commonProcessors'
import { formatLlmModelDisplay } from '@/utils/llmModelDisplay'
import { toast } from 'sonner'

const testChatCommonProcessors = commonProcessors.filter(
  (p) => p.type !== 'provider_switched'
)

export const testChatProcessors: MessageProcessor[] = [
  {
    type: 'bot_response',
    handler: (data) => {
      const isBotFinalizing = data.streaming === false

      if (data.message !== undefined && data.message !== null) {
        const ragChunks = Array.isArray(data.ragChunks)
          ? data.ragChunks
          : undefined

        store.dispatch(
          addMessage({
            id: data.message_id || data.id || Date.now(),
            message: data.message,
            user: data.user,
            streaming: data.streaming,
            ragChunks,
            llm_provider: data.llm_provider,
            llm_model_name: data.llm_model_name,
            created_at: isBotFinalizing
              ? data.created_at ?? new Date().toISOString()
              : data.created_at,
          })
        )
      } else if (isBotFinalizing) {
        store.dispatch(
          addMessage({
            id: data.message_id || data.id || Date.now(),
            message: '',
            user: data.user,
            streaming: false,
            llm_provider: data.llm_provider,
            llm_model_name: data.llm_model_name,
            created_at: data.created_at ?? new Date().toISOString(),
          })
        )
      }

      if (data.streaming) {
        store.dispatch(setIsGenerating(true))
      }

      if (isBotFinalizing) {
        store.dispatch(setIsGenerating(false))
      }
    },
  },
  {
    type: 'provider_switched',
    handler: (data) => {
      const providerDisplayName =
        formatLlmModelDisplay(data.llm_model_name, data.provider) ??
        (data.provider === 'openai' ? 'OpenAI' : 'Claude')

      toast.info(`Switched to ${providerDisplayName} due to service issues`)

      if (data.message_id) {
        const state = store.getState()
        const existing = state.testChatMessages.messages.find(
          (msg) => String(msg.id) === String(data.message_id)
        )
        if (existing) {
          store.dispatch(
            updateTestChatMessage({
              ...existing,
              message: '',
              llm_provider: data.provider,
              llm_model_name: data.llm_model_name,
            })
          )
        }
      }
    },
  },
  {
    type: 'save_success',
    handler: (data) => {
      if (data.total_messages && data.total_messages > 0) {
        toast.success(data.message || 'Test chat saved successfully!')
      } else {
        toast.info(data.message || 'No new messages to save')
      }
    },
  },
  {
    type: 'save_error',
    handler: (data) => {
      toast.error(data.message || 'Failed to save test chat')
      store.dispatch(setError(data.message || 'Failed to save test chat'))
    },
  },
  {
    type: 'existing_test_chats',
    handler: (data) => {
      store.dispatch(setExistingTestChats(data.data || []))
    },
  },
  ...testChatCommonProcessors,
]
